import React from 'react';
import { Route, BrowserRouter, Routes } from 'react-router-dom'

// components
import MainNav from './navigation/MainNav';

// pages
import Homepage from '../pages/Homepage';
import FullEvent from '../pages/FullEvent';
import Category from '../pages/Category';
import Video from '../pages/Video';
import VideoList from '../pages/VideoList';
import About from '../pages/About';
import Static from '../pages/Static';
import ErrorPage from '../pages/ErrorPage';

function Main() {
  return (

    <section id="main">
      <BrowserRouter>
        <MainNav />

        <Routes>
            <Route exact path="/" element={ <Homepage /> } />
            <Route path="/about" element={ <About />} />
            <Route path="/event" element={ <FullEvent />} />
            <Route path="/category" element={ <Category />} />
            <Route path="/video" element={ <Video />} />
            <Route path="/allvideos" element={ <VideoList />} />
            <Route path="/static" element={ <Static />} />
            <Route path="/error" element={ <ErrorPage /> } />
         </Routes>
      </BrowserRouter>
    </section>

  );
}

export default Main;